import { forwardRef } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import { Box, makeStyles, Typography, Button } from '@material-ui/core';
import Slide from '@mui/material/Slide';
import { useNavigate } from 'react-router';

import { ROUTES_AUTHEN } from 'src/constants';

const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    padding: '1.5rem 3rem',
    [theme.breakpoints.down(700)]: {
      padding: '1.5rem 2rem'
    }
  },
  title: {
    margin: '1rem 0 3rem',
    '& h5': {
      fontWeight: '600',
      textAlign: 'center'
    },
    [theme.breakpoints.down(700)]: {
      padding: '0 1rem'
    }
  },
  wrapButton: {
    display: 'flex',
    justifyContent: 'center',
    margin: '5rem 0',
    [theme.breakpoints.down(700)]: {
      flexDirection: 'column',
      margin: '2rem 0'
    }
  },
  buttonBack: {
    backgroundColor: '#A7A7A7 !important',
    color: '#fff !important'
  },
  buttonDelete: {
    backgroundColor: 'black !important',
    color: '#fff !important'
  },
  button: {
    padding: '12px 0 !important',
    borderRadius: 0,
    width: '100%',
    color: '#fff !important',
    '&:hover': {
      backgroundColor: '#1175ae'
    }
  }
}));

export default function CheckPaymentDialog({ open, onClose, pathName }) {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      TransitionComponent={Transition}
      open={open}
      aria-describedby="alert-dialog-slide-description"
    >
      <Box className={clsx(classes.dialogContainer)}>
        <Box className={clsx(classes.title)}>
          <Typography style={{ fontSize: 16 }}>
            <strong>有料会員様限定コンテンツとなります。</strong>
          </Typography>
        </Box>

        <Box mt={2}>
          <Button
            onClick={() => {
              navigate(pathName);
              handleClose();
            }}
            className={clsx(classes.button, classes.buttonBack)}
          >
            戻る
          </Button>
        </Box>
        <Box mt={2}>
          <Button
            onClick={() => {
              handleClose();
              navigate(ROUTES_AUTHEN.PAYMENT_TYPE);
            }}
            className={clsx(classes.button, classes.buttonDelete)}
          >
            決済確認
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}

CheckPaymentDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  pathName: PropTypes.string.isRequired
};

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
